/**
 * Human-readable message for a failed `supabase.functions.invoke()`.
 *
 * functions-js reports every non-2xx response as the fixed string "Edge
 * Function returned a non-2xx status code" and leaves the JSON body on
 * `error.context`. This digs the real `{ error }` / `{ message }` out so an
 * admin sees what actually failed instead of a generic line.
 */
export const edgeErrorMessage = async (error: unknown, data: unknown): Promise<string> => {
  const dataErr = (data as { error?: unknown } | null)?.error;
  if (typeof dataErr === "string" && dataErr) return dataErr;
  const ctx = (error as { context?: unknown } | null)?.context;
  if (ctx && typeof (ctx as Response).json === "function") {
    try {
      const body = await (ctx as Response).json();
      const msg = body?.error ?? body?.message;
      if (msg) return String(msg);
    } catch { /* not json */ }
  }
  if (error instanceof Error && error.message) return error.message;
  return "Unknown error";
};
